import GlossaryItem from '../Models/GlossaryItem';
import DataGridRequest from './DataGridRequest';
export class GlossaryRequest extends DataGridRequest<GlossaryItem> {
    Url = 'glossary/api';
}
